export default __webpack_public_path__ + "static/media/3.b5059b07.png";